import { cn } from "@/lib/utils";

const MAP = {
  accrued: { label: "Accrued", cls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  payable: { label: "Payable", cls: "border-primary/40 bg-primary/10 text-primary" },
  paid: { label: "Paid", cls: "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
  reversed: { label: "Reversed", cls: "border-destructive/40 bg-destructive/10 text-destructive" },
  signed: { label: "Signed", cls: "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
  unsigned: { label: "Unsigned", cls: "border-muted-foreground/30 bg-muted text-muted-foreground" },
  needs_resign: { label: "Needs Re-sign", cls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  draft: { label: "Draft", cls: "border-muted-foreground/30 bg-muted text-muted-foreground" },
  approved: { label: "Approved", cls: "border-primary/40 bg-primary/10 text-primary" },
  active: { label: "Active", cls: "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
  frozen: { label: "Frozen", cls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  inactive: { label: "Inactive", cls: "border-destructive/40 bg-destructive/10 text-destructive" },
  pending: { label: "Pending", cls: "border-muted-foreground/30 bg-muted text-muted-foreground" },
  held: { label: "Held", cls: "border-destructive/40 bg-destructive/10 text-destructive" },
  unattributed: { label: "Unattributed", cls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  house: { label: "House", cls: "border-border bg-muted text-muted-foreground" },
  attributed: { label: "Attributed", cls: "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
  assigned: { label: "Assigned (manual)", cls: "border-primary/40 bg-primary/10 text-primary" },
  critical: { label: "Critical", cls: "border-destructive/40 bg-destructive/10 text-destructive" },
  warning: { label: "Warning", cls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
};

export function StatusBadge({ status, className }) {
  const m = MAP[status] || { label: status, cls: "border-border bg-muted text-muted-foreground" };
  return (
    <span data-testid={`badge-${status}`}
      className={cn("inline-flex items-center rounded-sm border px-2 py-0.5 text-[11px] font-mono font-medium uppercase tracking-wider", m.cls, className)}>
      {m.label}
    </span>
  );
}
